/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SkillNode { 
    id: string;
    name: string;
    areaName: string;
    areaId: string;
    subareaName: string;
    subareaId: string;
    isWatched: boolean;
    watchedChildrenCount: number;
    firstLevelDone: boolean;
    secondLevelDone: boolean;
    thirdLevelDone: boolean;
    firstLevelChildrenDoneCount: number;
    secondLevelChildrenDoneCount: number;
    thirdLevelChildrenDoneCount: number;
    touchCount: number;
}